import * as React from "react";
import { useEffect } from "react";
import { Spinner } from "components/common";
import { useStore } from "stores/connect";
import { EventNotificationsActions, EventNotificationsStore } from "stores/event-notifications/EventNotificationsStore";
import LegacyNotificationSummary from "./LegacyNotificationSummary";
const LegacyNotificationSummaryContainer = ({ ...props }) => {
  const { allLegacyTypes } = useStore(EventNotificationsStore);
  useEffect(() => {
    EventNotificationsActions.listAllLegacyTypes();
  }, []);
  if (!allLegacyTypes) {
    return /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading legacy notification information..." }));
  }
  return /* @__PURE__ */ React.createElement(LegacyNotificationSummary, { ...props, legacyTypes: allLegacyTypes });
};
export default LegacyNotificationSummaryContainer;
